module.exports = __webpack_public_path__ + "static/img/requests__hovered.af33bcd.svg";